import { createReducer, on } from "@ngrx/store";
import * as analyticsActions from "./actions";
import { AnalyticsState, initialState } from "./state";

export const analyticsReducer = createReducer(
  initialState,

  on(analyticsActions.setFilters, (state, { filters }): AnalyticsState => ({ ...state, filters: { ...state.filters, ...filters } })),

  on(analyticsActions.loadSections, (state, { sections, preset }): AnalyticsState =>
    sections.reduce(
      (next, section) => ({ ...next, [section]: { ...next[section], requestedPreset: preset ?? state.filters.preset, loading: true, error: null } }),
      state,
    ),
  ),

  on(analyticsActions.loadSectionSuccess, (state, { section, data, preset }): AnalyticsState =>
    state[section].requestedPreset && state[section].requestedPreset !== preset
      ? state
      : { ...state, [section]: { data, loadedPreset: preset, requestedPreset: state[section].requestedPreset, loading: false, error: null } },
  ),

  on(analyticsActions.loadSectionFailure, (state, { section, error }): AnalyticsState => ({
    ...state,
    [section]: { ...state[section], loading: false, error },
  })),

  on(analyticsActions.loadCampaignDetail, (state, { campaignId }): AnalyticsState => ({
    ...state,
    campaignDetails: {
      ...state.campaignDetails,
      [campaignId]: { data: state.campaignDetails[campaignId]?.data ?? null, loading: true, error: null },
    },
  })),

  on(analyticsActions.loadCampaignDetailSuccess, (state, { campaignId, data }): AnalyticsState => ({
    ...state,
    campaignDetails: { ...state.campaignDetails, [campaignId]: { data, loading: false, error: null } },
  })),

  on(analyticsActions.loadCampaignDetailFailure, (state, { campaignId, error }): AnalyticsState => ({
    ...state,
    campaignDetails: { ...state.campaignDetails, [campaignId]: { data: state.campaignDetails[campaignId]?.data ?? null, loading: false, error } },
  })),

  on(analyticsActions.reset, (): AnalyticsState => initialState),
);
